import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {useGetCohortSettings} from "@/app2/shared/data";
import {useOwnedCohortId} from "@/app2/shared/hooks/useCohort";
import {UsersListGrid} from "./UsersListGrid";

const useStyles = makeStyles()((theme) => ({
	adminUsersList: {
		"& th": {
			fontSize: "11px",
			fontWeight: 700,
			textTransform: "uppercase"
		}
	}
}));

/**
 * Admin Users List (App2)
 *
 * Lists users in the admin's cohort with server-side pagination, sorting, and filtering.
 * Replaces legacy AdminUsersList that used /api/user.
 */
export const AdminUsersList: FC = () => {
	const {classes} = useStyles();
	const {t} = useSSTranslation();
	const cohortId = useOwnedCohortId();
	const {data: cohortSettings} = useGetCohortSettings(cohortId ?? 0, {
		enabled: !!cohortId
	});

	return (
		<Box className={classes.adminUsersList}>
			<AdminHeader
				title={t("admin_learner_progress_title", "Learner Progress")}
				subtitle={t("admin_users_list_subtitle", "View and manage learner progress")}
			/>
			<UsersListGrid organization={cohortSettings} />
		</Box>
	);
};
